import { unref, ref, computed, onMounted, type MaybeRef } from 'vue';
interface IntelliSuggestOrderItem {
    sku: string;
    childSku?: string;
    qty: number;
    price: number;
}
export function useIntelliSuggest({
    siteId,
    context,
    seed,
    shopperId
}: {
    siteId: MaybeRef<string>;
    context: MaybeRef<string>;
    seed: MaybeRef<string[]>;
    shopperId?: MaybeRef<string>;
}){

    siteId = ref(siteId);
    context = ref(context);
    seed = ref(seed);
    shopperId = ref(shopperId);


    function setShopperId(id: MaybeRef<string>){
        shopperId.value = unref(id);

         try {
            IntelliSuggest.setShopperId(shopperId.value);
        } catch (e) {
            console.error("Intellisuggest set shopper ID error: ", e);
        }
    }
    function init(){
        try{
            let payload = {
                siteId: siteId.value,
            };
            if(context.value){
                payload.context = context.value;
            }
            if(seed.value){
                payload.seed = seed.value;
            }
            
            IntelliSuggest.init(payload)
            setShopperId(shopperId);
        }catch(err){
            throw new Error("Intellisuggest init error: ", err);
        }
    }

    function inBasket({
        items,
    }){
        try{
            init();
            for(const item of items){
                IntelliSuggest.haveItem(item);
            }
            IntelliSuggest.setCurrency({
                code: 'USD'
            });
            IntelliSuggest.inBasket({});

        }catch(err){
            console.error("Intellisuggest inBasket error: ", err);
        }
    }

    function sale({
        items,
        orderId,
        total,
        city,
        state,
        country,
        currency
    }: {
        items: IntelliSuggestOrderItem[];
        orderId: string|number,
        total: number,
        city?: string,
        state?: string,
        country: string,
        currency?: string,
    }){
        try{
            init();
            for(const item of items){
                IntelliSuggest.haveItem(item);
            }
            IntelliSuggest.setCurrency({
                code: currency ?? 'USD'
            })

            IntelliSuggest.inSale({
                orderId,
                total,
                city,
                state,
                country
            })


        }catch(err){
            console.error("Intellisuggest sale error: ", err);
        }
    }

    function trackClick(el, intellisuggestData, intellisuggestSignature){
        try{
            init();
            IntelliSuggest.clickItem(el,{
                siteId: siteId.value,
                intellisuggestData,
                intellisuggestSignature
            });
        }catch(err){
            console.error("Intellisuggest track click error: ", err);
        }
    }


    return {
        setShopperId,
        init,
        sale,
        inBasket,
        trackClick
    }

}